// STATE UPDATE CONSTANTS

export const SET_AUTH_STATUS = 'SET_AUTH_STATUS';
export const UPDATE_ACCESS_DATA = 'UPDATE_ACCESS_DATA';
export const VERIFACTION_CODE_SUCCESS = 'VERIFACTION_CODE_SUCCESS';
export const UPDATE_SIGNEDUP_FACULTY_ACCOUNTS = 'UPDATE_SIGNEDUP_FACULTY_ACCOUNTS';
export const UPDATE_FACULTY_CACHE_STATUS = 'UPDATE_FACULTY_CACHE_STATUS';
export const UPDATE_ALL_FACULTY_ACCOUNTS = 'UPDATE_ALL_FACULTY_ACCOUNTS';
export const UPDATE_STUDENT_ACCOUNTS = 'UPDATE_STUDENT_ACCOUNTS';
export const UPDATE_ALL_COURSES = 'UPDATE_ALL_COURSES';
export const UPDATE_ACADLY_COURSES = 'UPDATE_ACADLY_COURSES';
export const UPDATE_COURSE_DETAILS = 'UPDATE_COURSE_DETAILS';
export const UPDATE_COURSE_ADMIN = 'UPDATE_COURSE_ADMIN';
export const UPDATE_COURSE_DATES = 'UPDATE_COURSE_DATES';
export const DELETE_WEEKLY_CLASS = 'DELETE_WEEKLY_CLASS';
export const UPDATE_COURSE_TIMELINE = 'UPDATE_COURSE_TIMELINE';
export const UPDATE_ENROLLMENTS = 'UPDATE_ENROLLMENTS';
export const PASSWORD_SET_SUCCESS = 'PASSWORD_SET_SUCCESS';
export const COURSE_CREATED = 'COURSE_CREATED';
